/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   Amina Rais
 *
 *******************************************************************************/

import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withStyles } from '@mui/styles'
import { Card, Grid, Typography } from '@mui/material'
import { CardContent } from '@material-ui/core'

const styles = theme => ({
    paper: {
        background: 'rgba(0, 0, 0, 0.5)',
    },
    typestyle: {
        lineHeight: '2.5em!important',
    },
    subtypestyle: {
        lineHeight: '2em!important',
    },
})

class ProivacyPolicyPage extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        const { classes } = this.props
        return (
            <>
                <Grid container spacing={4} style={{ marginTop: '50px' }}>
                    <Grid item xs={12} sm={12} md={3} />
                    <Grid item xs={12} sm={12} md={6}>

                        <Card>
                            <CardContent>
                                <Typography variant="h2" className={classes.typestyle}>
                                    <b>
                                        Privacy Policy

                                    </b>
                                </Typography>
                                <Typography variant="h3" className={classes.subtypestyle}>
                                    Please read these privacy policy carefully before using "theraytek.tn" website operated by theraytek.
                                </Typography>
                                <Typography variant="h2" className={classes.typestyle}>
                                    <b>
                                        DATA PRIVACY

                                    </b>
                                </Typography>


                                <Typography variant="h3" className={classes.subtypestyle}>
                                    We do not sell or trade your personal data with third-parties for commercial gains.
                                    We use a range of technological measures to ensure the privacy and
                                    accuracy of your data, including restricted access to personal data on a “need to know basis.”


                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>




            </>
        )
    }
}

ProivacyPolicyPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

function mapStateToProps() {
    return {}
}

const styledProivacyPolicyPage = withStyles(styles)(ProivacyPolicyPage)
const connectedProivacyPolicyPage = connect(mapStateToProps)(styledProivacyPolicyPage)
export { connectedProivacyPolicyPage as ProivacyPolicyPage }
